import React from 'react'
import { FooterContainer, FooterWrap } from './FooterElements'

const Footer = () => {
    return (
        <FooterContainer>
            <FooterWrap>
                <p>&copy; Copyright by Michał Wojcieszak</p>
                <p>Designed by Piotr Orłowski</p>
            </FooterWrap>
        </FooterContainer>
    )
}

export default Footer
